// The ONE door a player's command goes through. Offline it is
// command() straight into the engine; in an online fight the battle
// carries a lockstep driver and the command is stamped, sent, and
// applied on every screen at the same tick (online/lockstep.js).
import { command } from "./battle.js";
export const issue = (b, side, cmd) => (b.driver ? b.driver.send(cmd) : command(b, side, cmd));
